import React, { useEffect, useState } from "react";
import { Alert, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

function formatRemaining(ms) {
  if (ms <= 0) return "00:00";
  const totalSec = Math.floor(ms / 1000);
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

/**
 * Contagem regressiva da pré-reserva de poltronas.
 */
const PreReservaTimer = ({ expiresAt, onExpired }) => {
  const { t } = useTranslation("chat");
  const [remainingMs, setRemainingMs] = useState(() => {
    if (!expiresAt) return 0;
    return Math.max(0, new Date(expiresAt).getTime() - Date.now());
  });

  useEffect(() => {
    if (!expiresAt) return undefined;
    const tick = () => {
      const ms = Math.max(0, new Date(expiresAt).getTime() - Date.now());
      setRemainingMs(ms);
      if (ms <= 0 && onExpired) onExpired();
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [expiresAt, onExpired]);

  if (!expiresAt) return null;

  const expired = remainingMs <= 0;
  const severity = expired ? "error" : remainingMs < 120000 ? "warning" : "info";

  return (
    <Alert severity={severity} sx={{ mb: 2 }}>
      <Typography variant="body2" fontWeight={600}>
        {expired ? t("bpeWizard.timerExpired") : t("bpeWizard.timerActive", { time: formatRemaining(remainingMs) })}
      </Typography>
      {!expired && (
        <Typography variant="caption" color="text.secondary" display="block">
          {t("bpeWizard.timerHint")}
        </Typography>
      )}
    </Alert>
  );
};

export default PreReservaTimer;
